import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import ImportDialog from '../../../../components/import/ImportDialog';
import { t } from '../../../../utils/textUtils';

const ImportTab = ({ project, projectId, onOpenImport, onImportSuccess }) => (
  <Box>
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
      <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#5D4037' }}>
        {t('IMPORT STRUKTUR PROYEK')}
      </Typography>

      <Button
        variant="contained"
        color="primary"
        startIcon={<DownloadIcon />}
        onClick={onOpenImport}
        sx={{ textTransform: 'none' }}
      >
        {t('UPLOAD LANGSUNG')}
      </Button>
    </Box>

    <Typography variant="body2" sx={{ color: '#8D6E63', mb: 3 }}>
      {t('IMPORT KATEGORI PEKERJAAN, UNIT MODULAR, DAN TUGAS DARI FILE EXCEL UNTUK PROYEK')}{' '}
      {project?.name || t('INI')}
    </Typography>

    <ImportDialog
      open
      onClose={() => {}}
      projectId={projectId}
      onImportSuccess={onImportSuccess}
      embedded
    />
  </Box>
);

export default ImportTab;
